/* LUGAZI: loads lugazi-alive-src.js (the untouched original) with small changes:
   - BOOK: the pages Leandro picked become the sideways chapter (in the order set in lugazi-world-boot.js)
   - BOOK: the sideways chapter moves faster per scrolled pixel (RAIL_SPEED 0.32 instead of 0.45)
   - test 4 (11 Oct): start page and BOOK are one page, so the start-page drawings keep their life (blinking face,
     tree face, figure, eyes) on that page too
   The CDN serves the file minified, so both spellings are patched. If anything goes wrong it falls back to the original file. */
(function () {
  var me = document.currentScript, src = me && me.src ? me.src.replace(/lugazi-alive\.js/, 'lugazi-alive-src.js') : '';
  if (!src) return;

  var R = window.__lgzRail || [8, 26], RAIL_FROM = R[0], RAIL_TO = R[1];   /* the rows that go sideways, set by lugazi-world-boot.js */

  var code = null;
  try {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', src, false);
    xhr.send(null);
    if (xhr.status >= 200 && xhr.status < 300) code = xhr.responseText;
  } catch (e) {}
  if (code) {
    /* the sideways rows are read from the order (lugazi-world-boot.js) at the moment the book is built, and the
       order itself is applied right before - so the two can never be out of step */
    var ch = '[[' + RAIL_FROM + ', ' + RAIL_TO + ']]', live = '(window.__lgzOrder ? [window.__lgzOrder()] : CHAPTERS)';
    code = code.replace('const CHAPTERS = [[15, 17]];', 'const CHAPTERS = ' + ch + ';')
               .replace('const RAIL_SPEED = 0.45;', 'const RAIL_SPEED = 0.32;')
               .replace('CHAPTERS=[[15,17]],RAIL_SPEED=.45', 'CHAPTERS=' + ch + ',RAIL_SPEED=.32')
               .replace('const rails = CHAPTERS.map(', 'const rails = ' + live + '.map(')
               .replace('const rails=CHAPTERS.map(', 'const rails=' + live + '.map(')
               /* the sideways pages follow the finger faster, so a quick flick never leaves the last pages behind */
               .replace('R.x += (target - R.x) * 0.12;', 'R.x += (target - R.x) * 0.24;')
               .replace('R.x+=(target-R.x)*.12,', 'R.x+=(target-R.x)*.24,')
               /* one page: the start-page drawings live on the page that is built as BOOK */
               .replace('document.body.dataset.lugaziView==="home"&&(initFaceBlink()', '/^(home|book)$/.test(document.body.dataset.lugaziView)&&(initFaceBlink()')
               .replace('document.body.dataset.lugaziView === "home") {', '/^(home|book)$/.test(document.body.dataset.lugaziView)) {');
    try { (0, eval)(code + '\n//# sourceURL=lugazi-alive.js'); window.__lgzAlive = 'v4'; } catch (e) { window.__lgzAlive = 'err:' + e; if (window.console) console.error(e); }
    return;
  }
  var s = document.createElement('script'); s.src = src; document.head.appendChild(s);
})();
